import { render, staticRenderFns } from "./ThresholdForm.vue?vue&type=template&id=81d4de9c"
import script from "./ThresholdForm.vue?vue&type=script&lang=js"
export * from "./ThresholdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports